import { saveGroup } from "./insertGroup";

/**
 * @throws {SaveGroupError}
 */
export const updateGroup = saveGroup("PUT");
